import { forwardRef, type ReactNode } from "react";

// The core sets the canvas's pixel size itself (240x160 for GBA, 160x144 for
// Game Boy) on each load; CSS only scales it up with integer-looking pixels.
// `overlay` covers the screen, e.g. the cover art while a game opens.
const Screen = forwardRef<HTMLCanvasElement, { hidden?: boolean; overlay?: ReactNode }>(function Screen(
  { hidden, overlay },
  ref,
) {
  return (
    <div className="screen-wrap" hidden={hidden}>
      <canvas ref={ref} className="screen" width={240} height={160} tabIndex={0} />
      {overlay && <div className="screen-overlay">{overlay}</div>}
    </div>
  );
});

export default Screen;
